// ============================================
// BCS SITE IMAGES - EASY TO SWAP CONFIGURATION
// ============================================
// To change any image, simply replace the URL below
// Stock photos use Pexels (PEXELS_API_KEY in backend .env)
// Recommended: Use images at least 1200px wide for best quality

export const siteImages = {
  // ==========================================
  // HOMEPAGE IMAGES
  // ==========================================
  
  hero: {
    // Industrial refinery at dusk background
    main: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/91wxao8t_aerial-view-oil-and-gas-refinery-plant-at-night-g-2025-09-08-11-32-28-utc-1920x1080.webp",
    alt: "Oil and gas refinery plant"
  },

  // ==========================================
  // SERVICES SECTION IMAGES
  // ==========================================
  
  services: {
    equipmentRepair: {
      // Pump bearing housing with blue epoxy coating
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/srurhdqz_IMG_9560.jpg",
      alt: "Pump bearing housing restoration with epoxy coating"
    },
    protectiveCoatings: {
      // Workers coating inside a large potable water tank
      url: "https://static.prod-images.emergentagent.com/jobs/0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/images/3c5e55f8c31aa8bb7aa76339cca3364314d47d64c51bd910e68ed713e5772c81.png",
      alt: "Workers applying protective coating inside potable water tank"
    },
    pipelineRepair: {
      // Carbon fiber pipe wrap application
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/5yrkan3h_2099579A-3461-4B60-AA8F-C0959891862B_1_201_a.jpeg",
      alt: "Carbon fiber pipe wrap repair application"
    },
    structuralRepair: {
      // Concrete structural repair with exposed rebar
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/pnhzndvk_structural%20repair.png",
      alt: "Concrete structural repair work"
    },
    hvacRepair: {
      // Blue epoxy coated tubesheet
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/qa6btkpt_image.png",
      alt: "Blue epoxy coated heat exchanger tubesheet"
    },
    industrialCleaning: {
      // Sandblasting / abrasive blasting worker
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/78ysjmwq_Is-Abrasive-Blasting-the-Right-Metal-Finishing-Solution-for-You-Featured-Image-1-300x235.webp",
      alt: "Worker sandblasting industrial surface"
    },
    tankRepair: {
      // Tank repair coating application
      url: "https://customer-assets.emergentagent.com/job_coatingsplus-bcs/artifacts/wd47bdzn_image.png",
      alt: "Worker applying protective coating inside storage tank"
    },
    roofRepair: {
      // Industrial roof waterproofing work
      url: "https://static.prod-images.emergentagent.com/jobs/6e9d5f6a-12b6-4858-ae2f-cff8113b52c9/images/4b170600025098a2f263a6e2cac12deeb10ee221b17377b10505d74ce6b24e3f.png",
      alt: "Industrial roof waterproofing and repair"
    },
    floorRepair: {
      // Industrial floor epoxy coating application
      url: "https://customer-assets.emergentagent.com/job_coatingsplus-bcs/artifacts/p4c619pl_326E03E2-837A-42A3-A91A-8E35C8581D24_1_105_c.jpeg",
      alt: "Industrial floor epoxy coating application"
    }
  },

  // ==========================================
  // INDUSTRIES SECTION IMAGES
  // ==========================================
  
  industries: {
    manufacturing: {
      // Bottling/production line manufacturing
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/eyj6imil_manufacturing.jpeg",
      alt: "Manufacturing production line"
    },
    oilGas: {
      // US refinery with American flag
      url: "https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/93m7cylr_67f12affe9ff7160e15d4c08.jpg",
      alt: "Oil and gas refinery with American flag"
    },
    powerGeneration: {
      // Power plant with cooling towers
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/un2l4g1v_power%20plant.avif",
      alt: "Power generation plant with cooling towers"
    },
    waterTreatment: {
      // Wastewater treatment clarifier tank
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/xzz19rzo_Wastewater-treatment-plant-clarifier.jpg",
      alt: "Wastewater treatment plant clarifier"
    },
    marine: {
      // Offshore oil rig platform from water level
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/43kfwiye_Screenshot%202026-01-17%20at%201.08.54%E2%80%AFPM.png",
      alt: "Offshore oil rig platform"
    },
    generalIndustrial: {
      // Industrial facility with equipment and epoxy flooring
      url: "https://customer-assets.emergentagent.com/job_0d5b4051-9dd9-40a6-a2c5-3f369c357dd1/artifacts/69izspol_genreal%20industry.jpg",
      alt: "General industrial facility"
    },
    petrochemical: {
      // Petrochemical processing plant
      url: "https://customer-assets.emergentagent.com/job_coatingsplus-bcs/artifacts/1mexn3g7_image.jpeg",
      alt: "Petrochemical processing facility"
    },
    generalIndustry: {
      // Chiller mechanical room equipment
      url: "https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/07mofjuh_5D785B8F-A44B-4323-973E-77C77DC6ED25_1_102_o.jpeg",
      alt: "Industrial chiller mechanical room"
    },
    windPower: {
      // Wind turbine farm with mountains
      url: "https://customer-assets.emergentagent.com/job_industrial-epoxy-1/artifacts/wr8vxusf_resize.webp",
      alt: "Wind power turbine farm"
    }
  },

  // ==========================================
  // SERVICE PAGE HERO IMAGES
  // ==========================================
  
  servicePages: {
    equipmentRepair: {
      url: "https://images.pexels.com/photos/32900156/pexels-photo-32900156.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Equipment repair in progress"
    },
    protectiveCoatings: {
      url: "https://images.pexels.com/photos/36215204/pexels-photo-36215204.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Protective coating being applied"
    },
    pipelineRepair: {
      url: "https://images.pexels.com/photos/372796/pexels-photo-372796.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Industrial pipeline system"
    },
    structuralRepair: {
      url: "https://images.pexels.com/photos/5138311/pexels-photo-5138311.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Structural repair work"
    },
    hvacRepair: {
      url: "https://images.pexels.com/photos/162523/graffiti-abandoned-factory-abandoned-factory-162523.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Heat exchanger tubesheet"
    },
    industrialCleaning: {
      url: "https://images.pexels.com/photos/12267903/pexels-photo-12267903.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Industrial surface preparation"
    },
    assetLifeExtension: {
      url: "https://images.pexels.com/photos/34718930/pexels-photo-34718930.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Asset maintenance and inspection"
    }
  },

  // ==========================================
  // ABOUT / TEAM IMAGES
  // ==========================================
  
  about: {
    team: {
      url: "https://images.pexels.com/photos/32845690/pexels-photo-32845690.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "BCS professional team"
    },
    facility: {
      url: "https://images.pexels.com/photos/36311180/pexels-photo-36311180.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Industrial facility"
    }
  },

  // ==========================================
  // CAREERS PAGE
  // ==========================================
  
  careers: {
    hero: {
      url: "https://images.pexels.com/photos/36673276/pexels-photo-36673276.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "Industrial worker with safety equipment"
    }
  }
};

// Helper function to get image with fallback
export const getImage = (category, key) => {
  try {
    if (siteImages[category] && siteImages[category][key]) {
      return siteImages[category][key];
    }
    // Return a placeholder if image not found
    return {
      url: "https://images.pexels.com/photos/36215202/pexels-photo-36215202.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "BCS Industrial Services"
    };
  } catch (e) {
    return {
      url: "https://images.pexels.com/photos/36215202/pexels-photo-36215202.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
      alt: "BCS Industrial Services"
    };
  }
};

export default siteImages;
